class Recorder {
    mediaRecorder;
    mediaBlob;

    constructor(stopCallback = null) {
        document.addEventListener("DOMContentLoaded", () => {
            this.create(stopCallback);
        });

        // if (navigator.mediaDevices) {
        //     const constraints = { audio: true };
        //     let chunks = [];

        //     navigator.mediaDevices
        //         .getUserMedia(constraints)
        //         .then((stream) => {
        //             this.mediaRecorder = new MediaRecorder(stream);

        //             this.mediaRecorder.onstop = (e) => {
        //                 this.mediaBlob = new Blob(chunks, {
        //                     type: "audio/webm; codecs=opus",
        //                 });

        //                 if (typeof stopCallback === "function") {
        //                     stopCallback(this.mediaBlob);
        //                 }

        //                 chunks = [];
        //             };

        //             this.mediaRecorder.ondataavailable = (e) => {
        //                 chunks.push(e.data);
        //             };
        //         })
        //         .catch((err) => {
        //             if (err.code == 0) {
        //                 console.error(
        //                     "Please confirm your microphone permissions."
        //                 );
        //             } else {
        //                 console.error(
        //                     `The following error occurred: ${err.message}`
        //                 );
        //             }
        //         });
        // }
    }

    create(stopCallback = null) {
        window.audioSettingModal.setupInputStream().then(() => {
            if (navigator.mediaDevices && inputStream) {
                let chunks = [];

                this.mediaRecorder = new MediaRecorder(inputStream);

                this.mediaRecorder.ondataavailable = (e) => {
                    if (e.data.size > 0) chunks.push(e.data);
                };

                this.mediaRecorder.onstop = () => {
                    this.mediaBlob = new Blob(chunks, {
                        type: "audio/webm",
                    });

                    if (typeof stopCallback === "function") {
                        stopCallback(this.mediaBlob);
                    }

                    chunks = [];
                };
            }
        });
    }

    start() {
        this.mediaRecorder?.start();
    }

    stop() {
        this.mediaRecorder?.stop();
    }

    getBlob() {
        return this.mediaBlob;
    }
}

class SpeakingApp {
    recorder = new Recorder(this.stopRecorderAction);
    recordSpeakingSections = null;
    medias = null;
    recorderData = [];
    speakingData = [];
    speakingContainer = null;
    partDefault = 3;
    trans = {
        part: [
            { title: "Part 1" },
            {
                title: "Part 2",
                subtitle: ["Question", "Prepare", "Start", "Speak"],
            },
            { title: "Part 3" },
        ],
        mode: ["Practice mode", "Test mode"],
        control: {
            mode: ["Practice mode", "Test mode"],
            start: "Start",
            previousQuestion: "Previous",
            nextQuestion: "Next question",
            caption: "CC",
            listen: "Listening",
            play: "Play",
            recording: "Recording",
            pause: "Pause",
            stopListening: "Start recording",
            stopRecording: "Stop recording",
            recordAgain: "Record again",
            playAnswer: "Play your answer",
            stopAnswer: "Stop your answer",
            repeat: "Repeat the question",
            raraphrase: "Paraphrase the question",
            sampleAnswer: "Sample answer",
        },
    };
    questionBtns = null;
    nowQuestionBtn = 0;
    newVideo = null;
    repeatTimes = 2;
    mediaCountDownSetInterval = null;
    countDownRecorderSetInterval = null;
    mediaRecorderStatusElement = null;

    constructor(targetSelector = "body") {
        this.targetLayout = document.querySelector(targetSelector);
        this.init();
    }

    init() {
        window.sau = {
            exercise:
                document.querySelector("#test-tabContent").dataset.apiExercise,
        };
        this.fetchMedias();

        this.checkMedias(() => {
            this.initData();
        });
    }

    checkMedias(callback = null) {
        var intervalTime = 500;
        var limitTime = 10000;
        var nowTime = 0;
        var allMediaStatus = [];
        var checkMediasInterval = setInterval(() => {
            allMediaStatus = [];
            this.medias.forEach((item) => {
                if (item.tagName == "VIDEO") {
                    allMediaStatus.push(item.readyState);
                }
            });

            nowTime += intervalTime;
            if (!allMediaStatus.includes(0) || nowTime >= limitTime) {
                clearInterval(checkMediasInterval);
                callback();
            }
        }, intervalTime);
    }

    fetchMedias() {
        this.recordSpeakingSections = this.targetLayout.querySelectorAll(
            ".speaking_question_content"
        );
        this.medias = this.targetLayout.querySelectorAll(
            ".speaking_question_content audio, .speaking_question_content video"
        );

        if (this.targetLayout.querySelectorAll(".video-player")) {
            this.targetLayout
                .querySelectorAll(".video-player .timeline")
                .forEach((item) => {
                    item.classList.add("d-none");
                });

            this.targetLayout
                .querySelectorAll(".video-player .controls")
                .forEach((item) => {
                    item.classList.add("d-none");
                });
        }

        this.recordSpeakingSections = Map.groupBy(
            this.recordSpeakingSections,
            (item) => {
                item.removeAttribute("class");
                item.classList.add("speaking_question_content");
                item.querySelectorAll(".subtitles").forEach((subtitle) => {
                    subtitle.classList.remove("d-none");
                });
                item.querySelectorAll("video, audio").forEach((item) => {
                    item.removeAttribute("controls");
                    item.setAttribute(
                        "controlslist",
                        "nodownload,nofullscreen,noremoteplayback"
                    );
                    item.setAttribute("playsinline", true);
                    item.dataset.status = "pause";

                    item.addEventListener(
                        "playing",
                        (mediaElement) => {
                            mediaElement.target.dataset.status = "playing";

                            var playBtn =
                                this.speakingContainer.querySelector(
                                    ".play-btn"
                                );
                            playBtn.innerHTML = this.trans.control.pause;
                            playBtn.dataset.status = "playing";
                        },
                        false
                    );

                    item.addEventListener(
                        "pause",
                        (mediaElement) => {
                            mediaElement.target.dataset.status = "pause";
                            var playBtn =
                                this.speakingContainer.querySelector(
                                    ".play-btn"
                                );
                            playBtn.innerHTML = this.trans.control.play;
                            playBtn.dataset.status = "paused";
                        },
                        false
                    );

                    item.addEventListener("ended", (mediaElement) => {}, false);
                });
                var audioRecorder = item.querySelector(".audio_recorder");
                return parseInt(audioRecorder.dataset.recorderQid);
            }
        );

        document.querySelectorAll(".has-recoder").forEach((item) => {
            this.toDataUrl(item.dataset.mediaUrl, (recoderBase64) => {
                this.recorderData[`${item.dataset.qid}_${item.dataset.index}`] =
                    recoderBase64;
            });
        });
    }

    toDataUrl(url, callback = null) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    }

    initData() {
        document
            .querySelectorAll(".speaking_question_content .audio_recorder")
            .forEach((item) => {
                this.speakingData.push({ ...item.dataset });
            });

        setTimeout(() => {
            this.speakingData = Map.groupBy(this.speakingData, (item) =>
                parseInt(item.part)
            );
            this.initLayout();
        }, 500);
    }

    initLayout() {
        this.speakingContainer = document.createElement("div");
        this.speakingContainer.classList.add("speaking-container");
        this.speakingContainer.dataset.practiceMode =
            document.querySelector("#test-tabContent")?.dataset.practiceMode ??
            1;
        this.speakingContainer.dataset.start = 0;
        this.speakingContainer.dataset.countDownStatus = 0;
        this.createTabs();
        this.targetLayout.prepend(this.speakingContainer);
        this.createControls();

        this.setupButtonClick();
    }

    createTabs() {
        var tabs = document.createElement("div");
        tabs.classList.add("tabs");

        var listQuestions = document.createElement("div");
        listQuestions.classList.add("list-questions");

        var tabContents = document.createElement("div");
        tabContents.classList.add("tab-contents");

        var controls = document.createElement("div");
        controls.classList.add("tab-controls");

        var questionIndex = 1;
        var setupActive = false;

        for (var i = 1; i <= this.partDefault; i++) {
            if (!this.speakingData.get(i)) {
                continue;
            }
            var tab = document.createElement("div");
            tab.classList.add("tab");
            tab.dataset.part = i;
            tab.innerHTML = this.trans.part[i - 1].title;

            var itemQuestion = document.createElement("div");
            itemQuestion.classList.add("item-question");
            itemQuestion.dataset.part = i;

            var tabContent = document.createElement("div");
            tabContent.classList.add("tab-content");
            tabContent.dataset.part = i;

            if (!setupActive) {
                tab.classList.add("active");
                itemQuestion.classList.add("active", "show");
                tabContent.classList.add("active", "show");

                setupActive = !setupActive;
            }

            for (var j = 1; j <= (i == 2 ? 4 : 1); j++) {
                this.speakingData.get(i)?.forEach((question, index) => {
                    var questionBtn = document.createElement("div");
                    questionBtn.classList.add("question-btn");
                    questionBtn.dataset.index = questionIndex;
                    questionBtn.dataset.part = i;
                    questionBtn.dataset.qid = question.recorderQid;
                    questionBtn.dataset.quid = question.recorderQuid;
                    questionBtn.dataset.rid = question.recorderRid;
                    questionBtn.dataset.recorderId = `${question.recorderQid}_0`;
                    questionBtn.dataset.timerLength =
                        question.recorderTimerLength;
                    questionBtn.dataset.waitTimeAfter =
                        question.recorderWaitTimeAfter;
                    questionBtn.dataset.waitTimeBefore =
                        question.recorderWaitTimeBefore;
                    questionBtn.dataset.mediaDuration =
                        this.recordSpeakingSections
                            .get(parseInt(question.recorderQid))[0]
                            .querySelector("video")?.duration ?? 0;
                    questionBtn.dataset.repeatTimes = 0;
                    var questionBtnContent = document.createElement("div");
                    questionBtnContent.innerHTML =
                        i == 2
                            ? this.trans.part[i - 1].subtitle[j - 1]
                            : index + 1;
                    questionBtn.append(questionBtnContent);
                    itemQuestion.append(questionBtn);

                    var questionContent = document.createElement("div");
                    questionContent.classList.add("question-content");
                    questionContent.dataset.index = questionIndex;
                    questionContent.dataset.part = i;
                    questionContent.dataset.qid = question.recorderQid;
                    questionContent.dataset.quid = question.recorderQuid;
                    questionContent.dataset.rid = question.recorderRid;

                    if (i == 2) {
                        var recordSpeakingSection =
                            this.recordSpeakingSections.get(
                                parseInt(question.recorderQid)
                            )[0];

                        if (j == 1) {
                            questionBtn.dataset.timerLength = 0;
                            questionBtn.dataset.waitTimeAfter = 0;
                            questionBtn.dataset.waitTimeBefore = 0;
                            var partQuestionDiv = document.createElement("div");
                            partQuestionDiv.classList.add(
                                "speaking_question_content"
                            );
                            questionBtn.dataset.mediaDuration =
                                recordSpeakingSection.querySelector(
                                    "video"
                                ).duration;
                            partQuestionDiv.append(
                                recordSpeakingSection
                                    .querySelector("video")
                                    .closest("p"),
                                recordSpeakingSection.querySelector(
                                    ".subtitles"
                                )
                            );
                            questionContent.append(partQuestionDiv);
                        } else if (j == 2) {
                            questionBtn.dataset.index = questionIndex - 1;
                            questionBtn.dataset.videoStopTime =
                                itemQuestion.children[
                                    itemQuestion.children.length - 2
                                ].dataset.mediaDuration | 0;
                            questionBtn.dataset.timerLength = 0;
                            questionBtn.dataset.waitTimeAfter = 0;
                            questionBtn.dataset.waitTimeBefore = 0;
                            questionBtn.dataset.mediaDuration =
                                question.recorderWaitTimeBefore;
                        } else if (j == 3) {
                            questionBtn.dataset.timerLength = 0;
                            questionBtn.dataset.waitTimeAfter = 0;
                            questionBtn.dataset.waitTimeBefore = 0;
                            questionBtn.dataset.mediaDuration =
                                recordSpeakingSection.querySelector(
                                    "video"
                                ).duration;
                            var partQuestionDiv = document.createElement("div");
                            partQuestionDiv.classList.add(
                                "speaking_question_content"
                            );
                            partQuestionDiv.append(
                                recordSpeakingSection
                                    .querySelector("video")
                                    .closest("p"),
                                recordSpeakingSection.querySelector(
                                    ".subtitles"
                                )
                            );
                            questionContent.append(partQuestionDiv);
                        } else {
                            questionBtn.dataset.index = questionIndex - 1;
                            questionBtn.dataset.videoStopTime =
                                itemQuestion.children[
                                    itemQuestion.children.length - 2
                                ].dataset.mediaDuration | 0;
                            questionContent.append(recordSpeakingSection);
                        }
                    } else {
                        questionContent.append(
                            this.recordSpeakingSections.get(
                                parseInt(question.recorderQid)
                            )[0]
                        );
                    }

                    this.recordSpeakingSections.get(
                        parseInt(question.recorderQid)
                    )[0].style.display = "block";
                    tabContent.append(questionContent);

                    if (index == 0 && j == 1) {
                        questionBtn.classList.add("active");
                        questionContent.classList.add("active", "show");
                    }

                    questionIndex++;
                });
            }

            tabs.append(tab);
            listQuestions.append(itemQuestion);
            tabContents.append(tabContent);
        }

        this.speakingContainer.append(
            tabs,
            listQuestions,
            tabContents,
            controls
        );

        this.questionBtns =
            this.speakingContainer.querySelectorAll(".question-btn");
    }

    createControls() {
        var tabControls = this.speakingContainer.querySelector(".tab-controls");

        var leftDiv = document.createElement("div");
        leftDiv.classList.add("control-left");

        var rightDiv = document.createElement("div");
        rightDiv.classList.add("control-right");

        leftDiv.append(this.createModeBtns(), this.createMediaRecorderStatus());

        rightDiv.append(this.createStartBtn(), this.createMediaControls());

        tabControls.append(leftDiv, rightDiv);
    }

    createModeBtns() {
        var speakingModeDiv = document.createElement("div");
        speakingModeDiv.classList.add("select-mode", "show");

        var speakingPracticeModeBtn = document.createElement("div");
        speakingPracticeModeBtn.classList.add("mode-btn", "practice-mode");
        speakingPracticeModeBtn.dataset.practiceMode = 1;
        speakingPracticeModeBtn.innerHTML = this.trans.control.mode[0];

        var speakingTestModeBtn = document.createElement("div");
        speakingTestModeBtn.classList.add("mode-btn", "test-mode");
        speakingTestModeBtn.dataset.practiceMode = 0;
        speakingTestModeBtn.innerHTML = this.trans.control.mode[1];

        speakingModeDiv.append(speakingPracticeModeBtn, speakingTestModeBtn);

        if (this.speakingContainer.dataset.practiceMode == 0) {
            speakingTestModeBtn.classList.add("active");
        } else {
            speakingPracticeModeBtn.classList.add("active");
        }

        if (document.querySelector("#test-tabContent")?.dataset.practiceMode) {
            if (this.speakingContainer.dataset.practiceMode == 0) {
                speakingPracticeModeBtn.classList.add("disabled");
            } else {
                speakingTestModeBtn.classList.add("disabled");
            }
        }

        return speakingModeDiv;
    }

    createMediaRecorderStatus() {
        var mediaRecorderStatusDiv = document.createElement("div");
        mediaRecorderStatusDiv.classList.add("media-recorder-status");
        // currentMode: question, record
        mediaRecorderStatusDiv.dataset.currentMode = "question";
        // currentStatus: stop, pause, recording, playing
        mediaRecorderStatusDiv.dataset.currentStatus = "stop";

        var mediaRecorderStatus = document.createElement("div");
        mediaRecorderStatus.classList.add("recorder-status");
        mediaRecorderStatus.innerHTML = this.trans.control.listen;

        var mediaRecorderStatusIcon = document.createElement("div");
        mediaRecorderStatusIcon.classList.add(
            "recorder-status-icon",
            "player-mode",
            "speaking-circle-motion-parent"
        );
        mediaRecorderStatusIcon.innerHTML =
            '<i class="fa-solid fas fa-headphones player"></i><i class="fa-solid fas fa-microphone recorder"></i><i class="fa-solid fas fa-play playrecorder play"></i><i class="fa-solid fas fa-stop playrecorder stop"></i>';

        var circleMotionParent = document.createElement("div");
        circleMotionParent.classList.add("speaking-circle-motion");
        mediaRecorderStatusIcon.append(
            circleMotionParent,
            circleMotionParent.cloneNode(true)
        );

        var mediaRecorderTimer = document.createElement("div");
        mediaRecorderTimer.classList.add("recorder-timer");
        var mediaRecorderTimerTotal = document.createElement("div");
        mediaRecorderTimerTotal.classList.add("recorder-timer-total");
        mediaRecorderTimerTotal.innerHTML = "00:00";
        var mediaRecorderTimerDuration = document.createElement("div");
        mediaRecorderTimerDuration.classList.add("recorder-timer-duration");
        mediaRecorderTimerDuration.innerHTML = "00:00";
        mediaRecorderTimer.append(
            mediaRecorderTimerDuration,
            mediaRecorderTimerTotal
        );

        mediaRecorderStatusDiv.append(
            mediaRecorderStatus,
            mediaRecorderStatusIcon,
            mediaRecorderTimer
        );

        return mediaRecorderStatusDiv;
    }

    createStartBtn() {
        var startTestDiv = document.createElement("div");
        startTestDiv.classList.add("start-content", "show");
        var startTestBtn = document.createElement("div");
        startTestBtn.classList.add("start-btn");
        startTestBtn.innerHTML = this.trans.control.start;

        startTestDiv.append(startTestBtn);

        return startTestDiv;
    }

    createMediaControls() {
        var mediaControls = document.createElement("div");
        mediaControls.classList.add("media-controls");

        var mediaControlRow1 = document.createElement("div");
        mediaControlRow1.classList.add("media-control-row");

        var previousBtn = document.createElement("div");
        previousBtn.classList.add("control-btn", "previous-btn");
        previousBtn.innerHTML = this.trans.control.previousQuestion;

        var nextBtn = document.createElement("div");
        nextBtn.classList.add("control-btn", "next-btn");
        nextBtn.innerHTML = this.trans.control.nextQuestion;

        var captionBtn = document.createElement("div");
        captionBtn.classList.add("control-btn", "caption-btn");
        captionBtn.innerHTML = this.trans.control.caption;

        mediaControlRow1.append(previousBtn, nextBtn, captionBtn);

        var mediaControlRow2 = document.createElement("div");
        mediaControlRow2.classList.add("media-control-row");

        var playMediaBtn = document.createElement("div");
        playMediaBtn.classList.add("control-btn", "play-btn");
        playMediaBtn.innerHTML = this.trans.control.pause;
        playMediaBtn.dataset.status = "paused";

        var recorderBtn = document.createElement("div");
        recorderBtn.classList.add("control-btn", "recorder-btn");
        recorderBtn.innerHTML = this.trans.control.stopListening;
        recorderBtn.dataset.type = "stopListening";

        mediaControlRow2.append(playMediaBtn, recorderBtn);

        var mediaControlRow3 = document.createElement("div");
        mediaControlRow3.classList.add("media-control-row");

        var repeatBtn = document.createElement("div");
        repeatBtn.classList.add("control-btn", "repeat-btn");
        repeatBtn.innerHTML = this.trans.control.repeat;

        mediaControlRow3.append(repeatBtn);

        var mediaControlRow4 = document.createElement("div");
        mediaControlRow4.classList.add("media-control-row");

        var raraphraseBtn = document.createElement("div");
        raraphraseBtn.classList.add(
            "control-btn",
            "raraphrase-btn",
            "disabled"
        );
        raraphraseBtn.innerHTML = this.trans.control.raraphrase;

        mediaControlRow4.append(raraphraseBtn);

        var mediaControlRow5 = document.createElement("div");
        mediaControlRow5.classList.add("media-control-row");

        var sampleAnswerBtn = document.createElement("div");
        sampleAnswerBtn.classList.add("control-btn", "sample-btn");
        sampleAnswerBtn.innerHTML = this.trans.control.sampleAnswer;

        mediaControlRow5.append(sampleAnswerBtn);

        mediaControls.append(
            mediaControlRow1,
            mediaControlRow2,
            mediaControlRow3,
            mediaControlRow4,
            mediaControlRow5
        );

        return mediaControls;
    }

    setupButtonClick() {
        this.speakingContainer.querySelectorAll(".tab").forEach((tab) => {
            tab.addEventListener("click", (event) => {
                var target = event.target.closest(".tab");

                this.tabClickEvent(target);
                this.tabSwitchActive(target);
            });
        });

        this.questionBtns.forEach((questionBtn) => {
            questionBtn.addEventListener("click", (event) => {
                var target = event.target.closest(".question-btn");

                this.questionBtnClickEvent(target);
                this.questionBtnSwitchActive(target);
            });
        });

        this.speakingContainer
            .querySelectorAll(".mode-btn")
            .forEach((modeBtn) => {
                modeBtn.addEventListener("click", (event) => {
                    var target = event.target.closest(".mode-btn");
                    var parent = target.closest(".select-mode");
                    parent.querySelector(".active")?.classList.remove("active");
                    target.classList.add("active");
                    this.speakingContainer.dataset.practiceMode =
                        target.dataset.practiceMode;
                });
            });

        this.speakingContainer
            .querySelector(".start-btn")
            .addEventListener("click", (event) => {
                this.recorder.create(this.stopRecorderAction);
                var target = event.target.closest(".start-btn");
                var tabControls = target.closest(".tab-controls");
                var controlLeft = tabControls.querySelector(".control-left");
                var controlRight = tabControls.querySelector(".control-right");
                controlLeft
                    .querySelector(".select-mode.show")
                    .classList.remove("show");
                this.mediaRecorderStatusElement = controlLeft.querySelector(
                    ".media-recorder-status"
                );
                this.mediaRecorderStatusElement.classList.add("show");
                controlRight
                    .querySelector(".start-content.show")
                    .classList.remove("show");
                controlRight
                    .querySelector(".media-controls")
                    .classList.add("show");
                this.speakingContainer.dataset.start = 1;

                this.questionBtnClickEvent(
                    this.questionBtns[this.nowQuestionBtn]
                );
                this.questionBtnSwitchActive(
                    this.questionBtns[this.nowQuestionBtn]
                );

                if (typeof window?.countdownTime !== "undefined") {
                    window?.countdownTime(true, window.exitTest);
                }
            });

        this.speakingContainer
            .querySelector(".previous-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".previous-btn");
                var timeout = 500;

                if (this.recorder.mediaRecorder?.state == "recording") {
                    timeout = 1000;
                    this.stopRecorder();
                }

                setTimeout(() => {
                    if (!this.stopClickEvent()) {
                        this.speakingContainer
                            .querySelectorAll(".question-btn")
                            [this.nowQuestionBtn - 1]?.click();
                    }
                }, timeout);
            });

        this.speakingContainer
            .querySelector(".next-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".sample-btn");
                var timeout = 500;

                if (this.recorder.mediaRecorder?.state == "recording") {
                    timeout = 1000;
                    this.stopRecorder();
                }

                setTimeout(() => {
                    if (
                        this.speakingContainer.querySelectorAll(
                            ".question-btn"
                        )[this.nowQuestionBtn + 1]
                    ) {
                        this.speakingContainer
                            .querySelectorAll(".question-btn")
                            [this.nowQuestionBtn + 1]?.click();
                    } else {
                        this.speakingContainer
                            .querySelectorAll(".control-btn")
                            .forEach((btn) => {
                                btn.classList.add("disabled");
                            });
                    }
                }, timeout);
            });

        this.speakingContainer
            .querySelector(".caption-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".caption-btn");
                var captions =
                    this.speakingContainer.querySelectorAll(".subtitles");

                if (!this.stopClickEvent()) {
                    target.classList.toggle("active");
                    captions.forEach((caption) => {
                        caption.classList.toggle("show");
                    });
                }
            });

        this.speakingContainer
            .querySelector(".play-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".play-btn");

                if (target.dataset.status == "playing") {
                    this.speakingContainer.dataset.countDownStatus = 0;
                    this.stopAllMedias();
                    this.updateMediaRecorderStatus("question", "pause");
                } else {
                    this.nowVedio?.play();
                    this.speakingContainer.dataset.countDownStatus = 1;
                    this.updateMediaRecorderStatus("question", "playing");
                }
            });

        this.speakingContainer
            .querySelector(".recorder-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".recorder-btn");
                if (target.dataset.type == "stopListening") {
                    clearInterval(this.mediaCountDownSetInterval);
                    clearInterval(this.countDownRecorderSetInterval);
                    this.startCountDownRecorderEvent();
                    this.updateMediaRecorderStatus("record", "recording");
                } else if (target.dataset.type == "recordAgain") {
                    if (this.checkExistRecord()) {
                        var itemKey = this.nowVedio.id.replace(
                            "listening_test_video_player_",
                            ""
                        );
                        delete this.recorderData[itemKey];
                    }

                    clearInterval(this.mediaCountDownSetInterval);
                    clearInterval(this.countDownRecorderSetInterval);
                    this.startCountDownRecorderEvent();
                    this.updateMediaRecorderStatus("record", "recording");
                } else {
                    clearInterval(this.mediaCountDownSetInterval);
                    clearInterval(this.countDownRecorderSetInterval);
                    target.dataset.type = "recordAgain";
                    target.innerHTML = this.trans.control.recordAgain;
                    this.stopRecorder();
                    this.updateMediaRecorderStatus("record", "stop");
                }
            });

        this.speakingContainer
            .querySelector(".repeat-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".repeat-btn");
                var timeout = 500;

                if (this.recorder.mediaRecorder?.state == "recording") {
                    timeout = 1000;
                    this.stopRecorder();
                }

                setTimeout(() => {
                    if (
                        this.stopClickEvent() &&
                        parseInt(
                            this.speakingContainer.querySelectorAll(
                                ".question-btn"
                            )[this.nowQuestionBtn].dataset.repeatTimes
                        ) >= this.repeatTimes
                    ) {
                        return;
                    }

                    var nowQuestionBtn =
                        this.speakingContainer.querySelectorAll(
                            ".question-btn"
                        )[this.nowQuestionBtn];

                    if (nowQuestionBtn.dataset.part == 2) {
                        this.speakingContainer
                            .querySelectorAll(
                                `.question-btn[data-part="${nowQuestionBtn.dataset.part}"]`
                            )[0]
                            ?.click();
                    } else {
                        nowQuestionBtn?.click();
                    }
                }, timeout);
            });

        this.speakingContainer
            .querySelector(".raraphrase-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".raraphrase-btn");
            });

        this.speakingContainer
            .querySelector(".sample-btn")
            .addEventListener("click", (event) => {
                var target = event.target.closest(".sample-btn");
            });

        this.speakingContainer
            .querySelector(".recorder-status-icon")
            .addEventListener("click", (event) => {
                var recorderStatusIcon = event.target.closest(
                    ".recorder-status-icon"
                );
                if (
                    !recorderStatusIcon.classList.contains("playrecorder-mode")
                ) {
                    return;
                }
                var recorderId = recorderStatusIcon.dataset.recorderId;
                var audioElement = document.getElementById(recorderId);
                var recorderStatus =
                    this.speakingContainer.querySelector(".recorder-status");

                if (audioElement.paused) {
                    window.audioSettingModal.changeAllAudioVolumeRange(
                        window.localStorage.getItem("soundVolume") ?? 1
                    );
                    recorderStatusIcon.classList.add("playing", "active");
                    audioElement.play();
                    this.updateMediaRecorderStatus("record", "playing");
                    recorderStatus.innerHTML = this.trans.control.stopAnswer;
                } else {
                    recorderStatusIcon.classList.remove("playing", "active");
                    audioElement.pause();
                    this.updateMediaRecorderStatus("record", "pause");
                    recorderStatus.innerHTML = this.trans.control.playAnswer;
                }

                audioElement.addEventListener(
                    "ended",
                    () => {
                        this.updateMediaRecorderStatus("record", "pause");
                        recorderStatus.innerHTML =
                            this.trans.control.playAnswer;
                    },
                    { once: true }
                );
            });
    }

    stopClickEvent() {
        return this.speakingContainer.dataset.practiceMode == 0 ? true : false;
    }

    tabClickEvent(target = null) {
        if (!target) {
            return;
        }
        var listQuestions =
            this.speakingContainer.querySelector(".list-questions");
        var questionBtnActived = listQuestions.querySelector(
            `[data-part="${target.dataset.part}"] .question-btn.active`
        );
        this.setNowQuestionNumber(questionBtnActived);
        this.questionBtnClickEvent(questionBtnActived);
    }

    tabSwitchActive(target = null) {
        if (!target) {
            return;
        }
        var parent = target.closest(".tabs");
        var listQuestions =
            this.speakingContainer.querySelector(".list-questions");
        var tabContents = this.speakingContainer.querySelector(".tab-contents");
        parent.querySelector(".active").classList.remove("active");
        target.classList.add("active");
        listQuestions
            .querySelector(".active.show")
            .classList.remove("active", "show");
        listQuestions
            .querySelector(`[data-part="${target.dataset.part}"]`)
            .classList.add("active", "show");
        tabContents
            .querySelector(".tab-content.active.show")
            .classList.remove("active", "show");
        tabContents
            .querySelector(`.tab-content[data-part="${target.dataset.part}"]`)
            .classList.add("active", "show");
    }

    questionBtnClickEvent(target = null) {
        if (!target) {
            return;
        }

        this.setNowQuestionNumber(target);
        this.goQuestionEvent(this.nowQuestionBtn);
        this.startCountDownMediaEvent();
    }

    questionBtnSwitchActive(target = null) {
        if (!target) {
            return;
        }

        var parent = target.closest(".item-question");
        var part = parent.dataset.part;
        var index = target.dataset.index;
        var targetTab = this.speakingContainer.querySelector(
            `.tab[data-part="${part}"]`
        );
        var targetTabContent = this.speakingContainer.querySelector(
            `.tab-content[data-part="${part}"]`
        );
        parent.querySelector(".active").classList.remove("active");
        target.classList.add("active");
        this.tabSwitchActive(targetTab);
        targetTabContent
            .querySelector(".active.show")
            .classList.remove("active", "show");
        targetTabContent
            .querySelector(`[data-index="${index}"]`)
            .classList.add("active", "show");
    }

    setNowQuestionNumber(target = null) {
        if (target) {
            this.nowQuestionBtn = Array.from(
                this.speakingContainer.querySelectorAll(".question-btn")
            ).indexOf(target);
        }
    }

    goQuestionEvent(questionNumber = 0) {
        var targetQuestionBtns =
            this.speakingContainer.querySelectorAll(".question-btn");
        var targetQuestionBtn = targetQuestionBtns[questionNumber];

        if (targetQuestionBtn) {
            if (targetQuestionBtn.dataset.part == 2) {
                this.speakingContainer
                    .querySelectorAll(
                        `.question-btn[data-part="${targetQuestionBtn.dataset.part}"]`
                    )
                    ?.forEach((btn) => {
                        btn.dataset.repeatTimes =
                            parseInt(targetQuestionBtn.dataset.repeatTimes) + 1;
                    });
            } else {
                targetQuestionBtn.dataset.repeatTimes =
                    parseInt(targetQuestionBtn.dataset.repeatTimes) + 1;
            }

            this.nowQuestionBtn = questionNumber;

            if (this.nowQuestionBtn <= 0) {
                this.speakingContainer
                    .querySelector(".previous-btn")
                    .classList.add("disabled");
                this.speakingContainer
                    .querySelector(".next-btn")
                    .classList.remove("disabled");
            } else if (this.nowQuestionBtn >= targetQuestionBtns.length - 1) {
                this.speakingContainer
                    .querySelector(".previous-btn")
                    .classList.remove("disabled");
                this.speakingContainer
                    .querySelector(".next-btn")
                    .classList.add("disabled");
            } else {
                this.speakingContainer
                    .querySelector(".previous-btn")
                    .classList.remove("disabled");
                this.speakingContainer
                    .querySelector(".next-btn")
                    .classList.remove("disabled");
            }

            if (
                this.stopClickEvent() &&
                parseInt(
                    this.speakingContainer.querySelectorAll(".question-btn")[
                        this.nowQuestionBtn
                    ].dataset.repeatTimes
                ) >= this.repeatTimes
            ) {
                this.speakingContainer
                    .querySelector(".repeat-btn")
                    .classList.add("disabled");
            } else {
                this.speakingContainer
                    .querySelector(".repeat-btn")
                    .classList.remove("disabled");
            }
        }
    }

    startCountDownMediaEvent() {
        var setIntervalTime = 50;
        var nowQuestion =
            this.speakingContainer.querySelectorAll(".question-btn")[
                this.nowQuestionBtn
            ];
        var mediaDuration = 0;

        this.stopAllMedias();

        var recorderStatusIcon = this.speakingContainer.querySelector(
            ".recorder-status-icon"
        );

        recorderStatusIcon.classList.remove(
            "recorder-mode",
            "playrecorder-mode",
            "playing"
        );
        recorderStatusIcon.classList.add("player-mode", "active");
        this.speakingContainer.dataset.countDownStatus = 1;

        var recorderStatus =
            this.speakingContainer.querySelector(".recorder-status");

        recorderStatus.innerHTML = this.trans.control.listen;

        if (this.mediaCountDownSetInterval) {
            clearInterval(this.mediaCountDownSetInterval);
        }

        if (this.countDownRecorderSetInterval) {
            clearInterval(this.countDownRecorderSetInterval);
        }

        if (!this.stopClickEvent()) {
            this.speakingContainer
                .querySelector(".play-btn")
                .classList.remove("disabled");
        }

        var recorderBtn = this.speakingContainer.querySelector(".recorder-btn");
        recorderBtn.innerHTML = this.trans.control.stopListening;
        recorderBtn.dataset.type = "stopListening";

        // this.updataMediaDuration(nowQuestion.dataset.mediaDuration);

        this.updataMediaDuration(
            this.speakingContainer.querySelectorAll(".question-btn")[
                this.nowQuestionBtn
            ]
        );

        this.mediaCountDownSetInterval = setInterval(() => {
            if (this.speakingContainer.dataset.countDownStatus == 0) {
                return;
            }
            this.speakingContainer.querySelector(
                ".recorder-timer-duration"
            ).innerHTML = this.displayTime(mediaDuration);
            if (nowQuestion.dataset.mediaDuration <= mediaDuration) {
                clearInterval(this.mediaCountDownSetInterval);
                this.speakingContainer
                    .querySelector(".play-btn")
                    .classList.add("disabled");
                this.speakingContainer.querySelector(
                    ".recorder-timer-duration"
                ).innerHTML = this.displayTime(
                    nowQuestion.dataset.mediaDuration
                );

                var partTwoProcess = false;
                if (nowQuestion.dataset.part == 2) {
                    var partTwoItem = document.querySelectorAll(
                        `.question-btn[data-part="${nowQuestion.dataset.part}"]`
                    );

                    partTwoProcess =
                        nowQuestion != partTwoItem[partTwoItem.length - 1];
                }

                if (
                    (this.stopClickEvent() &&
                        nowQuestion.dataset.timerLength == 0) ||
                    partTwoProcess
                ) {
                    this.speakingContainer.dataset.countDownStatus = 0;
                    document.querySelector(".next-btn").click();
                } else {
                    var timerLength = nowQuestion.dataset.timerLength;
                    var recorderId = nowQuestion.dataset.recorderId;
                    if (this.recorderData[recorderId]) {
                        var recorderBtn =
                            this.speakingContainer.querySelector(
                                ".recorder-btn"
                            );
                        recorderBtn.dataset.type = "recordAgain";
                        recorderBtn.innerHTML = this.trans.control.recordAgain;
                        this.stopRecorderAction(this.recorderData[recorderId]);
                        this.speakingContainer.querySelector(
                            ".recorder-timer-duration"
                        ).innerHTML = this.displayTime(timerLength);
                        this.updataMediaDuration(timerLength);
                        this.updateMediaRecorderStatus("record", "stop");
                    } else {
                        this.startCountDownRecorderEvent();
                    }
                }
            }
            mediaDuration += setIntervalTime / 1000;
        }, setIntervalTime);

        this.updateMediaRecorderStatus("question", "playing");
    }

    startCountDownRecorderEvent() {
        var recorderBtn = this.speakingContainer.querySelector(".recorder-btn");
        var setIntervalTime = 50;
        var nowQuestion = this.questionBtns[this.nowQuestionBtn];
        var timerLength = nowQuestion.dataset.timerLength;

        if (this.nowVedio) {
            this.nowVedio.currentTime = this.nowVedio.duration;
        }
        this.stopAllMedias();

        var recorderStatusIcon = this.speakingContainer.querySelector(
            ".recorder-status-icon"
        );

        recorderStatusIcon.classList.remove("player-mode", "playrecorder-mode");
        recorderStatusIcon.classList.add("recorder-mode", "active");

        var recorderStatus =
            this.speakingContainer.querySelector(".recorder-status");

        recorderStatus.innerHTML = this.trans.control.recording;

        this.speakingContainer.dataset.countDownStatus = 1;

        if (this.mediaCountDownSetInterval) {
            clearInterval(this.mediaCountDownSetInterval);
        }

        if (this.countDownRecorderSetInterval) {
            clearInterval(this.countDownRecorderSetInterval);
        }

        this.speakingContainer
            .querySelector(".play-btn")
            .classList.add("disabled");

        recorderBtn.innerHTML = this.trans.control.stopRecording;
        recorderBtn.dataset.type = "stopRecording";

        if (timerLength > 0) {
            this.recorder.start();
        }

        this.updataMediaDuration(timerLength);
        this.countDownRecorderSetInterval = setInterval(() => {
            if (this.speakingContainer.dataset.countDownStatus == 0) {
                return;
            }

            this.speakingContainer.querySelector(
                ".recorder-timer-duration"
            ).innerHTML = this.displayTime(timerLength);
            if (timerLength <= 0) {
                this.stopRecorder();
                clearInterval(this.countDownRecorderSetInterval);
                recorderBtn.dataset.type = "recordAgain";
                recorderBtn.innerHTML = this.trans.control.recordAgain;

                this.speakingContainer.querySelector(
                    ".recorder-timer-duration"
                ).innerHTML = this.displayTime(0);

                var recorderStatusIcon = this.speakingContainer.querySelector(
                    ".recorder-status-icon"
                );
                recorderStatusIcon.classList.remove(
                    "player-mode",
                    "recorder-mode",
                    "active"
                );
                recorderStatusIcon.classList.add("playrecorder-mode");

                this.updateMediaRecorderStatus("record", "stop");

                if (this.stopClickEvent()) {
                    document.querySelector(".next-btn").click();
                }
            }
            timerLength -= setIntervalTime / 1000;
        }, setIntervalTime);

        this.updateMediaRecorderStatus("record", "recording");
    }

    stopRecorder() {
        this.recorder.stop();
    }

    stopRecorderAction(mediaBlob = null) {
        var _this = window.SpeakingApp;
        var itemKey = _this.nowVedio.id.replace(
            "listening_test_video_player_",
            ""
        );
        var from =
            document.querySelector("form#test-tabContent") ||
            document.querySelector("form#exerciseForm");
        var questionContent = _this.nowVedio.closest(".question-content");

        _this.blobToBase64(mediaBlob, (base64) => {
            var recorderStatusIcon = _this.speakingContainer.querySelector(
                ".recorder-status-icon"
            );
            var recorderTimerDuration = _this.speakingContainer.querySelector(
                ".recorder-timer-duration"
            );
            var soundElement = document.getElementById(itemKey);
            if (!soundElement) {
                soundElement = document.createElement("audio");
                soundElement.classList.add("d-none");
                soundElement.id = itemKey;
                soundElement.controls = "true";
                document
                    .querySelector(".question-type-content")
                    .append(soundElement);
                soundElement.addEventListener("loadedmetadata", (event) => {
                    recorderTimerDuration.innerHTML = _this.displayTime(
                        event.target.currentTime
                    );
                });

                soundElement.addEventListener("timeupdate", (event) => {
                    recorderTimerDuration.innerHTML = _this.displayTime(
                        event.target.currentTime
                    );
                });

                soundElement.addEventListener("ended", (event) => {
                    recorderStatusIcon.classList.remove("playing", "active");
                });
            }
            soundElement.src = base64;
            sessionStorage.setItem(
                `speaking_answer_save_${itemKey}`,
                JSON.stringify({
                    audioData: base64,
                    audioSource: "exercise",
                    ck: from.dataset.connect,
                    crsf_token: from.querySelector('[name="_token"]').value,
                    qid: questionContent.dataset.qid,
                    quid: questionContent.dataset.quid,
                    rid: questionContent.dataset.rid,
                    ui: from.dataset.uid,
                    uploadedResult: "",
                })
            );

            _this.recorderData[itemKey] = base64;

            var recorderStatus =
                _this.speakingContainer.querySelector(".recorder-status");
            recorderStatus.innerHTML = _this.trans.control.playAnswer;

            recorderStatusIcon.classList.remove(
                "player-mode",
                "recorder-mode",
                "active"
            );
            recorderStatusIcon.classList.add("playrecorder-mode");
            recorderStatusIcon.dataset.recorderId = itemKey;
        });
    }

    blobToBase64 = (blob, callback) => {
        if (typeof blob == "string") {
            callback(blob);
        } else {
            var reader = new FileReader();
            reader.onload = function () {
                var base64 = reader.result;
                callback(base64);
            };
            reader.readAsDataURL(blob);
        }
    };

    stopAllMedias() {
        document.querySelectorAll("audio, video").forEach((media) => {
            if (media.dataset.status != "pause") {
                media.pause();
            }
        });
    }

    updataMediaDuration(playMedia = null) {
        var recorderTimerTotal = this.speakingContainer.querySelector(
            ".recorder-timer-total"
        );

        var mediaDuration = 0;

        if (typeof playMedia == "object") {
            this.nowVedio = this.speakingContainer.querySelector(
                `.question-content[data-index="${playMedia.dataset.index}"][data-qid="${playMedia.dataset.qid}"] video`
            );

            mediaDuration = playMedia.dataset.mediaDuration;

            if (this.nowVedio) {
                if (isNaN(mediaDuration)) {
                    mediaDuration = this.nowVedio.duration;
                    playMedia.dataset.mediaDuration = mediaDuration;
                }

                this.nowVedio.currentTime = 0;
                if (playMedia.dataset?.videoStopTime) {
                    this.nowVedio.currentTime =
                        playMedia.dataset?.videoStopTime;
                } else {
                    this.nowVedio.play();
                }
            }
        } else {
            mediaDuration = playMedia;

            if (this.questionBtns[this.nowQuestionBtn].dataset.part == 2) {
                this.nowVedio = this.speakingContainer.querySelector(
                    `.question-content[data-qid="${
                        this.questionBtns[this.nowQuestionBtn].dataset.qid
                    }"] video`
                );
            }
        }

        recorderTimerTotal.innerHTML = this.displayTime(
            parseInt(mediaDuration)
        );
    }

    checkExistRecord() {
        var itemKey = this.nowVedio.id.replace(
            "listening_test_video_player_",
            ""
        );

        if (this.recorderData[itemKey] != undefined) {
            return true;
        }

        return false;
    }

    displayTimeString(mediaTime) {
        var day = 24 * 60 * 60;
        var hour = 60 * 60;
        var minute = 60;
        var days = parseInt(mediaTime / day);
        var hours = parseInt((mediaTime % day) / hour);
        var minutes = parseInt(((mediaTime % day) % hour) / minute);
        var seconds = parseInt(((mediaTime % day) % hour) % minute);

        return (
            (days > 0 ? (days > 1 ? `${days} days ` : `${days} day `) : "") +
            (hours > 0
                ? hours > 1
                    ? `${hours} hours `
                    : `${hours} hour `
                : "") +
            (minutes > 0
                ? minutes > 1
                    ? `${minutes} minutes `
                    : `${minutes} minute `
                : "") +
            (minutes <= 2
                ? seconds > 0
                    ? seconds > 1
                        ? `${seconds} seconds`
                        : `${seconds} second`
                    : ""
                : "")
        );
    }

    displayTime(mediaTime) {
        var hour = 60 * 60;
        var minute = 60;
        var hours = parseInt(mediaTime / hour);
        var minutes = parseInt((mediaTime % hour) / minute);
        var seconds = parseInt((mediaTime % hour) % minute);

        return (
            (hours > 0 ? (hours >= 10 ? `${hours}:` : `0${hours}:`) : "") +
            (minutes >= 0
                ? minutes >= 10
                    ? `${minutes}:`
                    : `0${minutes}:`
                : "") +
            (seconds >= 0 ? (seconds >= 10 ? `${seconds}` : `0${seconds}`) : "")
        );
    }

    updateMediaRecorderStatus(mode, status) {
        this.mediaRecorderStatusElement.dataset.currentMode = mode;
        this.mediaRecorderStatusElement.dataset.currentStatus = status;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    window.SpeakingApp = new SpeakingApp(".question-type-content");
});
